import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1349a272"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "trip-details" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "You have missed some required fields above. Please check your selected options", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BookingHeader = _resolveComponent("BookingHeader")!
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_TripAmendmentHeader = _resolveComponent("TripAmendmentHeader")!
  const _component_TripModeOfTravel = _resolveComponent("TripModeOfTravel")!
  const _component_TripRoute = _resolveComponent("TripRoute")!
  const _component_TripCalendar = _resolveComponent("TripCalendar")!
  const _component_TripPassengerSelect = _resolveComponent("TripPassengerSelect")!
  const _component_TripDiscount = _resolveComponent("TripDiscount")!
  const _component_BaseSection = _resolveComponent("BaseSection")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BookingHeader, { title: 'Book' }),
    (_ctx.initializing)
      ? (_openBlock(), _createBlock(_component_BaseSpinner, {
          key: 0,
          size: 40
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_TripAmendmentHeader, { isAmendment: _ctx.isAmendmentMode }, null, 8, ["isAmendment"]),
          _createVNode(_component_TripModeOfTravel),
          _createVNode(_component_TripRoute),
          _createVNode(_component_TripCalendar),
          _createVNode(_component_TripPassengerSelect, {
            disabled: _ctx.isPartlyLocked === true
          }, null, 8, ["disabled"]),
          (!_ctx.isAmendmentMode)
            ? (_openBlock(), _createBlock(_component_TripDiscount, { key: 0 }))
            : _createCommentVNode("", true),
          (_ctx.v$.$errors.length > 0)
            ? (_openBlock(), _createBlock(_component_BaseSection, {
                key: 1,
                errors: _ctx.v$.$errors
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "default", {}, () => [
                    _hoisted_2
                  ], true)
                ]),
                _: 3
              }, 8, ["errors"]))
            : _createCommentVNode("", true)
        ], 64))
  ]))
}